import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'store';
import { setAuthState } from '../store/slice/UserSlice';

/**
 * Renders an error message for unauthorized users
 * @returns {JSX.Element} the error message component
 */
export const Unauthenticated = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [showMessage, setShowMessage] = useState(false);
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout>>();

  const user = useSelector((state: AppState) => state.user);

  useEffect(() => {
    if (user?.authState !== 'logout') {
      if (showMessage) {
        setShowMessage(false);
      }
      setTimer(setTimeout(() => setShowMessage(true), 5000));
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
      dispatch(setAuthState('initial'));
    };
  }, [user?.authState]);

  return (showMessage && <h4>{t('pageErrors.unauthenticated')}</h4>) || null;
};
